/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.17.0
 */

import styled from 'styled-components';

import { FormBlockStyled } from '../../../../components/common/FormStyled/FormStyled';
import { fonts } from '../../../../theme';

export const PageAutoReportIdFormatDeliveryStyled = styled.div.attrs({
    className: 'format-delivery',
})`

    ${FormBlockStyled} {
        margin-left: 0;
        margin-bottom: 8px;
    }

    .format-delivery__group {
        width: fit-content;
        margin-bottom: 24px;
    }

    .format-delivery__field {
        width: 450px;
        margin-left: 32px;
    }

    .format-delivery__title {
        ${fonts.textMainBold};
        margin-bottom: 8px;
    }
`;
